import { render, staticRenderFns } from "./StaffLeftTree.vue?vue&type=template&id=2127837e"
import script from "./StaffLeftTree.vue?vue&type=script&lang=js"
export * from "./StaffLeftTree.vue?vue&type=script&lang=js"
import style0 from "./StaffLeftTree.vue?vue&type=style&index=0&id=2127837e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports